
import { DASHBOARD_LIST, DASHBOARD_LIST_ERROR, DASHBOARD_LIST_SUCCESS, GRADE_LIST, GRADE_LIST_ERROR, GRADE_LIST_SUCCESS, LOAD_DATALOSS_GRAPH, LOAD_DATALOSS_GRAPH_ERROR, LOAD_DATALOSS_GRAPH_SUCCESS, NOTIFICATION_MANAGEMENT_LIST, NOTIFICATION_MANAGEMENT_LIST_ERROR, NOTIFICATION_MANAGEMENT_LIST_SUCCESS, PIDS_GRAPH, PIDS_GRAPH_ERROR, PIDS_GRAPH_SUCCESS, PIDS_STATUS, PIDS_STATUS_ERROR, PIDS_STATUS_SUCCESS, REGION_LIST, REGION_LIST_ERROR, REGION_LIST_SUCCESS, STS_DASHBOARD_LIST, STS_DASHBOARD_LIST_ERROR, STS_DASHBOARD_LIST_SUCCESS, TLP_DASHBOARD_LIST, TLP_DASHBOARD_LIST_ERROR, TLP_DASHBOARD_LIST_SUCCESS } from './constants';

export default function regiondata(state, action) {
	let stsfilter = [];
	let pagination = {};

	switch (action.type) {
      
	case REGION_LIST:
		return { ...state, pending: true };
	case REGION_LIST_SUCCESS:
		return { ...state, regiondata: action.payload, pending: false };
	case REGION_LIST_ERROR:
		return { ...state, error: true };


	case DASHBOARD_LIST:
		return { ...state, pending: true };
	case DASHBOARD_LIST_SUCCESS:
		return { ...state, dashboarddata: action.payload, pending: false };
	case DASHBOARD_LIST_ERROR:
		return { ...state, error: true };
	case PIDS_STATUS : 
		return { ...state, pending: true };
	case PIDS_STATUS_SUCCESS :
		return { ...state, pidsStatus: action.payload.data, pending: false };
	case PIDS_STATUS_ERROR :
		return { ...state, error: true };

	case PIDS_GRAPH : 
		return { ...state, pending: true };
	case PIDS_GRAPH_SUCCESS :
		return { ...state,pending: false };
	case PIDS_GRAPH_ERROR :
		return { ...state, error: true, pending:false };

	case TLP_DASHBOARD_LIST:
		return { ...state, pending: true };
	case TLP_DASHBOARD_LIST_SUCCESS:
		return { ...state, tlpdashboarddata: action.payload, pending: false };
	case TLP_DASHBOARD_LIST_ERROR:
		return { ...state, error: true };
	
	case STS_DASHBOARD_LIST:
		return { ...state, pending: true };
	case STS_DASHBOARD_LIST_SUCCESS:
		return { ...state, stsdashboarddata: action.payload, pending: false };
	case STS_DASHBOARD_LIST_ERROR:
		return { ...state, error: true };
	case LOAD_DATALOSS_GRAPH:
		return {...state, loading : true};
	case LOAD_DATALOSS_GRAPH_SUCCESS:
		return {...state, loading : false, heatmapData : action.payload};
	case LOAD_DATALOSS_GRAPH_ERROR:
		return {...state, loading : false};

	case NOTIFICATION_MANAGEMENT_LIST:
		return {...state, loading: true, error : false};
	case NOTIFICATION_MANAGEMENT_LIST_SUCCESS :
	
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.label = item.name;
	
				return stsfilter.push(data);
			});
			return { ...state, stsfilter:stsfilter , pagination: pagination, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, stsfilter : [] , pagination: pagination, loading: false, error: false };
			} else {
				return { ...state,stsfilter : [] , loading: false, error: true };
			}
		}
	case NOTIFICATION_MANAGEMENT_LIST_ERROR :
		return { ...state, loading : false, error : true };

	case GRADE_LIST:
		return { ...state, pending: true };
	case GRADE_LIST_SUCCESS:
		return { ...state, grade_data: action.payload, pending: false };

	case GRADE_LIST_ERROR:
		return { ...state, error: true, pending: false };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}